import React from 'react';
import { SectionHeader, FadeIn } from '../ui';
export function FAQ() {
  const faqs = [{
    q: 'Who is Atrium Homes?',
    a: 'A Perth family-owned luxury custom home builder, building for over 50 years across three generations of the Marcolina family.'
  }, {
    q: 'What does Atrium specialise in?',
    a: 'Luxury custom homes in Perth and WA.'
  }, {
    q: 'Where is Atrium based?',
    a: '9 Willcock Street, Ardross WA 6153.'
  }, {
    q: 'Does Atrium have a display home?',
    a: 'Yes, Latitude at 27 Simpson Street, Applecross, with a new Dalkeith display coming soon.'
  }, {
    q: 'What awards has Atrium won?',
    a: 'HIA and MBA awards and finalist recognition since 1995, including a 2024 HIA Custom Built Home win.'
  }, {
    q: 'Who leads Atrium?',
    a: 'Directors Adam and Daniel Marcolina.'
  }, {
    q: 'How do I start a custom home?',
    a: 'Book a private design consultation or call (08) 6310 8888.'
  }, {
    q: 'Can Atrium assess a block before purchase?',
    a: 'Yes, preliminary site evaluation considering lifestyle, orientation and budget; final feasibility depends on survey, soil, drainage and council factors.'
  }, {
    q: 'Does Atrium work with international clients?',
    a: 'Yes, with land sourcing, design and migration-agent introductions.'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-205">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-206">
        <FadeIn data-id="element-207">
          <SectionHeader eyebrow="Quick Answers" title="Quick answers about Atrium Homes" className="text-center" data-id="element-208" />
        </FadeIn>

        {/* Native <details>/<summary> for AEO: answers live in the DOM
            regardless of JS, fully machine-extractable. */}
        <div className="mt-12" itemScope itemType="https://schema.org/FAQPage" data-id="element-209">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index % 5 * 50} data-id="element-210">
              <details className="group border-b border-atrium-stone/40" open={index === 0} itemScope itemProp="mainEntity" itemType="https://schema.org/Question" data-id="element-211">
                <summary className="w-full py-6 flex items-center justify-between text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atrium-bronze/60 focus-visible:ring-offset-2" data-id="element-212">
                  <h3 className="font-serif text-lg text-atrium-ink group-hover:text-atrium-green transition-colors pr-8" itemProp="name" data-id="element-213">
                    {faq.q}
                  </h3>
                  <span className="flex-shrink-0 text-atrium-bronze ml-4" data-id="element-214">
                    <svg className="w-5 h-5 transition-transform duration-300 group-open:rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" data-id="element-215">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-216" />
                    </svg>
                  </span>
                </summary>
                <div className="pb-6 pr-8" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer" data-id="element-217">
                  <p className="text-sm text-atrium-ink/80 leading-relaxed" itemProp="text" data-id="element-218">
                    {faq.a}
                  </p>
                </div>
              </details>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}